import { ReactNode } from "react";
import { CalloutBox } from "../base/callout-box";
import { Style } from "./alert-variants";

interface WarningCalloutProps {
  children: ReactNode;
  style?: Style;
}

export const WarningCallout = ({ children, style = "outlined" }: WarningCalloutProps) => {
  return (
    <CalloutBox color="amber" style={style} className="inline">
      {children}
    </CalloutBox>
  );
};
